import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { VideoWithUrl } from "src/app/model/video-youtube/video-youtube";
import { YoutubeVideoDialogComponent } from "./youtube-video-dialog/youtube-video-dialog.component";

@Component({
    selector: 'app-youtube-video',
    templateUrl: './youtube-video.component.html',
    styleUrls: ['./youtube-video.component.scss']
})
export class YoutubeVideoComponent {
    @Input() video: VideoWithUrl;
    @Input() isSuperAdmin: boolean = false;

    @Output() saveUpdateVideo = new EventEmitter<any>();
    @Output() deleteVideo = new EventEmitter<any>();

    constructor(
        public dialog: MatDialog,
    ) {}

    edit(video: any) {
        const dialogRef = this.dialog.open( YoutubeVideoDialogComponent, {
            width: '250px',
            data: video,
          });
  
          dialogRef.afterClosed().subscribe(result => {
              if(result !== undefined) {
                  this.saveUpdateVideo.emit(result.data);
              }
            });
    }

    delete(video: any) {
        this.deleteVideo.emit(video);
    }
}